import axios from 'axios';

export default (getOptions) => ({
    FetchCommit: (type, apply) => axios.get(`/api/judge/commit/pvt/${type}/${apply}`, getOptions()),
    UpdateCommit: (type, apply, data) => axios.put(`/api/judge/commit/pvt/${type}/${apply}`, data, getOptions()),
    SubmitCommit: (type, apply) => axios.post(`/api/judge/commit/pvt/${type}/${apply}/submit`, {}, getOptions()),
    ListSubmitCommits: (type, apply) => axios.get(`/api/judge/commit/pvt/${type}/${apply}/submit/list`, getOptions()),
    CancelSubmitCommit: (type, apply, commit) => axios.delete(`/api/judge/commit/pvt/${type}/${apply}/${commit}`, getOptions()),
});
